import { buildCrmCardRegistry } from 'crm-cards/buildCrmCardRegistry';
import { CRM_CARDS_GLOBAL_REGISTRY_MAP } from './CrmCardsGlobalRegistry';
export function buildGlobalCrmCardRegistry(overrideRegistryMap) {
  const registryMap = overrideRegistryMap ? Object.assign({}, CRM_CARDS_GLOBAL_REGISTRY_MAP, overrideRegistryMap) : CRM_CARDS_GLOBAL_REGISTRY_MAP;
  const registry = buildCrmCardRegistry(registryMap);
  // @ts-expect-error This is a private property that is only used in crm-card-infra-frontend
  registry._unsafeIsGlobalRegistry = true;
  return registry;
}